export default {
  SET_SITE_OWNERS: function (state, payload) {
    state.siteOwners = payload;
  }
}
